<template>
    <div class="login">
        <div class="login_div">
            <el-form className="register_container" label-position="left" label-width="110px" :rules="rule"
                     :model="loginForm">
                <h2 className="login_title">找回密码</h2>

                <el-form-item label="邮箱" prop="email" style="margin-top: 50px">
                    <el-input type="email" v-model="loginForm.email" auto-complete="off"
                              placeholder="请输入邮箱地址"></el-input>
                </el-form-item>

                <el-form-item label="邮箱验证码" prop="email" style="margin-top: 30px">
                    <el-input type="email" v-model="loginForm.email" auto-complete="off"
                              placeholder="请输入邮箱地址"></el-input>
                    <el-button v-if="!isCounting" type="warning" style="width: 100px;margin-top: 10px" class="login-btn"
                               @click="sendEmailCode('loginForm')">获取验证码
                    </el-button>

                    <el-button v-if="isCounting"  type="success" style="width:50px;margin-top: 10px" class="login-btn">{{count}} s
                    </el-button>
                </el-form-item>

                <el-form-item label="账号" prop="username" style="margin-top: 30px">
                    <el-input type="text" v-model="loginForm.username" auto-complete="off"
                              placeholder="请输入账号"></el-input>
                </el-form-item>

                <el-form-item label="密码" prop="password" style="margin-top: 30px">
                    <el-input type="password" v-model="loginForm.password" auto-complete="off"
                              placeholder="请输入密码"></el-input>
                </el-form-item>


                <el-button type="primary" style="width: 100%;background: lightpink;border: none" class="login-btn"
                           @click="register('loginForm')">注册
                </el-button>

                <div class="register">
                    <el-button type="primary" style="width: 30%;border: none" class="login-btn"
                               @click="login()">返回登录
                    </el-button>
                    <el-button type="danger" style="width: 30%;border: none" class="login-btn"
                               @click="register()">注册用户
                    </el-button>
                </div>
            </el-form>


        </div>
    </div>
</template>


<script>
    import {register,sendEmailCode} from '../../api/admin/admin';
    import {ElMessage} from 'element-plus';

    export default {
        name: "Login",
        data() {
            return {
                count: 60, // 倒计时初始值
                timer: null, // 用于存储定时器的引用
                isCounting: false,// 控制按钮是否可点击
                loading: true,
                loginForm: {
                    username: '',
                    password: '',
                    email: ""
                },
                rule: {
                    username: [
                        {required: true, message: '用户名不能为空！', trigger: 'blur'}
                    ],
                    password: [
                        {required: true, message: '密码不能为空！', trigger: 'blur'}
                    ],
                    email: [
                        {required: true, message: '邮箱不能为空！', trigger: 'blur'}
                    ],
                },
            }
        },

        beforeDestroy() {
            if (this.timer) {
                clearInterval(this.timer); // 清除定时器，防止内存泄漏
            }
        },
        methods: {
            //发送邮箱验证码
            sendEmailCode() {
                const userInfo = window.sessionStorage.getItem('userInfo');
                const user = JSON.parse(userInfo);
                if (null==userInfo) {
                    ElMessage.error("请先登录");
                    this.$router.replace("/login");
                    return;
                }

                const userId=user.id;
                sendEmailCode(userId).then(res => {
                    const code = res.data.code;
                    const errormsg = res.data.errormsg;
                    console.log(res.data);
                    if (code === "200") {
                        this.$router.replace("/forget");
                        this.loading = false;

                        this.isCounting = true; // 开始倒计时，禁用按钮
                        this.timer = setInterval(() => {
                            if (this.count > 0 && this.count <= 60) {
                                this.count--; // 每次调用减少1秒
                            } else {
                                this.stopCountdown(); // 当倒计时结束时停止倒计时
                            }
                        }, 1000); // 每1000毫秒（1秒）执行一次

                        ElMessage({
                            message: '发送成功',
                            type: 'success',
                        });
                    } else {
                        ElMessage.error(errormsg);
                    }
                });


            },
            stopCountdown() {
                clearInterval(this.timer); // 清除定时器
                this.timer = null; // 重置定时器引用
                this.count = 60; // 重置倒计时时间
                this.isCounting = false; // 允许按钮再次点击
            },


            login() {
                this.$router.replace("/login");
            },
            //注册
            register(formName) {
                const email = this.loginForm.email;
                const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
                const checkEmail = emailRegex.test(email);
                if (!checkEmail) {
                    ElMessage.error("请输入正确邮箱地址");
                    return;
                }
                this.loading = true;
                register(this.loginForm).then(res => {
                    const code = res.data.code;
                    const errormsg = res.data.errormsg;
                    console.log(res.data);
                    if (code === "200") {
                        this.$router.replace("/login");
                        this.loading = false;



                        ElMessage({
                            message: '注册成功',
                            type: 'success',
                        });
                    } else {
                        ElMessage.error(errormsg);
                    }
                });

            }
        }
    }
</script>

<style lang="less" scoped>
    .login {
        background: url("../../assets/img/loginBC2.png") no-repeat;
        background-position: center;
        height: 100%;
        width: 100%;
        background-size: cover;
        position: fixed;

        .login_div {
            /*margin-top: auto;*/
            margin-top: 10%;
        }

        h2 {
            font-weight: bolder;
            font-size: 20px;
            letter-spacing: 5px;
            /*color: deepskyblue;*/
            text-align: center;

        }
    }

    body {
        margin: 0;
        padding: 0;
    }

    .register_container {
        border-radius: 15px;
        background-clip: padding-box;
        margin: 90px auto;
        width: 350px;
        height: 350px;
        padding: 35px 35px 15px 35px;
        background: #fff;
        border: 1px solid #eaeaea;
        box-shadow: 0 0 25px #cac6c6;
    }

    .login_title {
        margin: 0 auto 40px auto;
        text-align: center;
        color: #505458;
    }

    .login-btn:hover {
        background: lightskyblue;
    }

    .register {
        margin-top: 10px;
        width: 100%;
        display: flex;
        justify-content: space-between;
    }


</style>
